<template>
  <div class="rbu-item-module-data-points">
    <ASorItemModuleDatapoint
      v-for="(datapoint, idx) in datapoints"
      :datapoint="datapoint"
      :idx="idx"
      :key="idx"
      @input="onDataPointUpdate(idx, $event)"
      @delete="onDataPointDelete(idx)"
    ></ASorItemModuleDatapoint>
  </div>
</template>

<script>
import ASorItemModuleDatapoint from "@/components/asor/ASorItemModuleDatapoint.vue";

export default {
  name: "AsorItemModuleDatapoints",
  components: { ASorItemModuleDatapoint },
  props: {
    item: Object,
    datapoints: Array,
  },
  setup(props, { root, emit }) {
    const onDataPointUpdate = function (idx, evt) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1, {
        ...props.datapoints[idx],
        ...evt,
      });
      emit("input", dataPoints);
    };

    const onDataPointDelete = function (idx) {
      let dataPoints = _.concat(props.datapoints || [], []);
      dataPoints.splice(idx, 1);
      emit("input", dataPoints);
    };

    return {
      onDataPointUpdate,
      onDataPointDelete,
    };
  },
};
</script>
